import { render, staticRenderFns } from "./JefeAdmisionView.vue?vue&type=template&id=5b1406de&scoped=true"
import script from "./JefeAdmisionView.vue?vue&type=script&lang=js"
export * from "./JefeAdmisionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1406de",
  null
  
)

export default component.exports